import { PluginConfig } from './types';
import { initializePlugin } from './initializePlugin';
import { applyTransaction } from './applyTransaction';

/**
 * Returns the Prosemirror plugin state object with the `init` and `apply` properties.
 * @param config - The plugin configuration object.
 * @returns The plugin state object.
 */
export function pluginState(config: PluginConfig) {
  return {
    init: initializePlugin(config),
    apply: applyTransaction,
  };
}
